import { gql } from '@apollo/client'

export const ZONE_FRAGMENT = gql`
  fragment Zone on Zone {
    id
    parentId
    name
  }
`
